import React from 'react';
import { IoCheckmarkOutline } from 'react-icons/io5';

const LicenseCard = ({ title, sub, price, info, note, perks, onChoose, buttonText = "Choose" }) => {
  return (
    <div className="license-card">
      <div className="card-title">
        <strong>{title}</strong><span className="green-text">/ {sub}</span>
      </div>
      <div className="price-box">
        {info && <span className="price-info">{info}</span>}
        <div className="price-main">
          <span className="currency">$</span>
          <span className="amount">{price}</span>
          {note && <span className="price-note">{note}</span>}
        </div>
      </div>
      <div className='perk-container'>
        <ul className="perk-list">
          {perks.map((perk, i) => (
            <li key={i}><IoCheckmarkOutline className="check-icon" /> {perk}</li>
          ))}
        </ul>
      </div>
      <button className="choose-btn" onClick={onChoose}>{buttonText}</button>
    </div>
  );
};

export default LicenseCard;
